module.exports = __webpack_public_path__ + "img/3.162f27c0.webp";